import React, { useContext, useState } from 'react';
import { ButtonAction, getIframeLegacyUrl } from '../donate-form-utils';
import { Dialog } from '../../../atoms/dialog';
import { DonateFormContext } from '../DonateFormContext';
import DonateFormButton from './DonateFormButton';
import { Button } from '../../../atoms/button';

interface PledgeDonationProps {
    action: ButtonAction;
}

const PledgeDonation = ({ action }: PledgeDonationProps) => {
    const { formState, canSubmitForm, config } = useContext(DonateFormContext);
    const { legacyUrl } = config;
    const [isDialogActive, setIsDialogActive] = useState(false);
    const [isThankYouDialog, setIsThankYouDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    // while legacy might be portal.test.giveeasy
    // the actual URL we use is test.giveeasy
    const iframeLegacyUrl = getIframeLegacyUrl(legacyUrl);

    const donatePledgeUrl = `${iframeLegacyUrl}/odata/paymentinfo/GiveEasy.CreatePledge`;

    const processPledgeDonation = async () => {
        setIsLoading(true);
        setHasError(false);
        try {
            const res = await fetch(donatePledgeUrl, {
                method: 'POST',
                headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    items: {
                        ...formState,
                        app_key: 'AxEppXJU99KGBJWBCt6mdDq3QsmW0B0O',
                        transaction: 'Pledge',
                    }
                })
            });

            if (!res.ok) {
                return;
            }

            setIsThankYouDialog(true);
        } catch {
            setHasError(true);
        }
        finally {
            setIsLoading(false);
        }

        return;
    }

    const onClose = () => setIsDialogActive(false);

    return (
        <div>
            <DonateFormButton
                id="credit-card-donate"
                action={action}
                onClick={() => setIsDialogActive(true)}
                disabled={!canSubmitForm}
            />
            <Dialog
                title={isThankYouDialog ? 'Your pledge was successful!' : 'Please confirm your donation'}
                contentSlot={
                    <div className="layout-grouping-children">
                        {isThankYouDialog ? (
                            <>
                                <p>Thanks! Your pledge of ${formState?.amount} has been received! A representative will be in contact shortly.</p>
                                <div>
                                    <Button
                                        id="pledge-confirm"
                                        appearance="new-primary"
                                        onClick={() => window.location.reload()}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="layout-spacing-bottom">Are you sure you want to pledge to donate ${formState?.amount}?</p>
                                <div>
                                    <Button
                                        id="pledge-confirm"
                                        appearance="new-primary"
                                        onClick={processPledgeDonation}
                                        isLoading={isLoading}
                                    >
                                        Confirm
                                    </Button>
                                </div>
                                {hasError && (<p style={{ color: 'red' }}>There was a problem with your request. Please try again</p>)}
                            </>
                        )}
                    </div>
                }
                isOpen={isDialogActive}
                onClose={onClose}
            />
        </div>
    )
}

export default PledgeDonation;
